<template>
  <div>
    <!-- 菜单 -->
    <el-col
      v-if="topButtonList != null && topButtonList.length > 0"
      :span="24"
      class="toolbar"
      style="padding-bottom: 0px"
    >
      <el-form :inline="true" @submit.native.prevent :model="filters">
        <el-form-item>
          <el-select
            v-model="filters.ActivityId"
            placeholder="请输入活动名称"
            :loading="loadingActivityName"
            filterable
            clearable
            remote
            reserve-keyword
            :remote-method="remoteMethod"
            @change="handleActName"
          >
            <el-option
              v-for="item in activityList"
              :key="item.ActivityId"
              :label="item.ActivityName"
              :value="item.ActivityId"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.Type" placeholder="模板类型" >
            <el-option label="请选择模板类型" :value="-1"></el-option>
            <el-option label="报名成功" value="0"></el-option>
            <el-option label="审核通过" value="1"></el-option>
            <el-option label="电子门票" value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-select v-model="filters.Status" placeholder="发送状态">
            <el-option label="请选择发送状态" :value="-1"></el-option>
            <el-option label="未发送" value="0"></el-option>
            <el-option label="等待回执" value="1"></el-option>
            <el-option label="发送失败" value="2"></el-option>
            <el-option label="发送成功" value="3"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-for="item in topButtonList" v-bind:key="item.id">
          <el-button
            v-prevent-re-click
            :type="
              item.Func &&
              (item.Func.toLowerCase().indexOf('handledel') != -1 ||
                item.Func.toLowerCase().indexOf('stop') != -1)
                ? 'danger'
                : 'primary'
            "
            v-if="!item.IsHide"
            @click="callFunc(item)"
            >{{ item.name }}</el-button
          >
        </el-form-item>
      </el-form>
    </el-col>
    
    <!-- 列表 -->
    <el-table
      border=""
      :data="tabData"
      v-loading="listLoading"
      style="width: 100%">
      <el-table-column type="index" label="序号" width="60"></el-table-column>
      <el-table-column prop="ActivityName" label="活动名称" width=""></el-table-column>
      <el-table-column prop="CompanyName" label="公司名称" width=""></el-table-column>
      <el-table-column prop="ReceiverName" label="姓名" width=""></el-table-column>
      <el-table-column prop="ReceiverContact" label="邮箱" width=""></el-table-column>
      <el-table-column prop="Type" label="发送类型" width="100">
        <template slot-scope="scope">
          <el-tag type="" v-if="scope.row.Type === 0">报名成功</el-tag>
          <el-tag type="info" v-else-if="scope.row.Type === 1">审核通过</el-tag>
          <el-tag type="primary" v-else-if="scope.row.Type === 2">电子门票</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="SendWay" label="发送方式" width="80" align="center">
        <template slot-scope="scope">
          <el-button
            :type="scope.row.Status === 0 ? 'info': scope.row.Status === 1 ? 'warning' : scope.row.Status === 2 ? 'danger' : scope.row.Status === 3 ? 'success' : '' "
            :icon="scope.row.SendWay === 1 ? 'el-icon-message' : 'el-icon-mobile-phone' "
            circle
            size="small"
          ></el-button>
        </template>
      </el-table-column>
      <el-table-column prop="Status" label="发送状态" width="100">
        <template slot-scope="scope">
          <el-tag type="info" v-if="scope.row.Status === 0">未发送</el-tag>
          <el-tag type="warning" v-else-if="scope.row.Status === 1">等待回执</el-tag>
          <el-tag type="danger" v-else-if="scope.row.Status === 2">发送失败</el-tag>
          <el-tag type="success" v-else-if="scope.row.Status === 3">发送成功</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="Remark" label="备注" width=""></el-table-column>
      <el-table-column prop="SendTime" label="发送时间" width="150"></el-table-column>
    </el-table>
    
    <!--工具条-->
    <el-pagination
      layout="total, sizes, prev, pager, next"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page.sync="filters.PageIndex"
      :page-sizes="[20, 40, 60, 80]"
      :page-size="filters.PageSize"
      :total="filters.total"
      style="float: right"
    ></el-pagination>

  </div>
</template>

<script>
import {
  getActivityList,
  ActivityNoticeList,
} from '../../api/api'
import { getButtonList } from '../../promissionRouter'
export default {
  data() {
    return {      
      topButtonList: [],
      filters:{
        ActivityId:'',
        Type:-1,
        Status: -1,
        PageIndex: 1, //第几页
        PageSize: 20, // 每页多少条
        total: 0, // 总记录
        pageCount: 1,
      },
      activityList: [], // 适用活动
      loadingActivityName: false, // 适用活动 加载效果
      tabData:[],
      listLoading: false,
      
    }
  },
  methods: {
    // 按钮点击事件传值
    callFunc(item, row) {
      this.currentRow = row
      this[item.Func].apply(this, item)
    },
    // 翻页事件
    handleSizeChange(pageSize) {
      this.filters.PageSize = pageSize
      this.handleQuery()
    },
    // 翻页事件
    handleCurrentChange(currentPage) {
      this.filters.PageIndex = currentPage
      this.handleQuery()
    },

    // 查询按钮
    handleQuery(){
      this.listLoading = true
      ActivityNoticeList(this.filters).then((res) => {
        console.log(res)
        if(res.data.success) {
          this.tabData = res.data.response.data
          this.filters.total = res.data.response.dataCount
          this.filters.pageCount = res.data.response.pageCount
          this.listLoading = false
        }
      })
    },
    
    // 适用的活动
    remoteMethod(query) {
      if (query !== '') {
        this.loadingActivityName = true
        setTimeout(() => {
          getActivityList(query).then((res) => {
            if (res.data.success) {
              this.activityList = res.data.response
              this.loadingActivityName = false
            }
          })
        }, 500)
      }
    },
    // 使用活动 选择事件，获取选择数据的值
    handleActName(val) {
      console.log('val', val)
      // this.ruleForm.ActivityId = val
      // this.ruleForm.ActivityName = val
      //   ? this.activityList.find((ele) => ele.ActivityId === val).ActivityName
      //   : ''
    },

  },
  mounted(){
    this.handleQuery();

    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : []
    let buttonList = getButtonList(this.$route.path, routers)
    this.topButtonList = buttonList.filter((item) => {
      return item.ButtonType === 0
    })
  }
}
</script>

<style>

</style>